<template>
  <div>
    <v-card-actions>
      <v-card-title>OUR ROLES</v-card-title>
      <v-btn fab small color="success" @click="roleAdd = true">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-actions>
    <project-role-view></project-role-view>
    <project-role-add
      :role-add="roleAdd"
      :role-list="roleList"
      @update-add-role-modal="updateRoleModal"
    ></project-role-add>
  </div>
</template>
<script>
import ProjectRoleAdd from "@/components/Projects/ProjectInnerCardsComp/ProjectRoleAdd";
import ProjectRoleView from "@/components/Projects/ProjectInnerCardsComp/ProjectRoleView";
export default {
  name: "ProjectRole",
  props: ["roleList"],
  components: {
    "project-role-view": ProjectRoleView,
    "project-role-add": ProjectRoleAdd,
  },
  data() {
    return {
      roleAdd: false,
      roleData: [],
    };
  },
  methods: {
    updateRoleModal(value) {
      this.roleAdd = value;
    },
  },
};
</script>
